const SDK_VERSION = '7.107.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
